export default __webpack_public_path__ + "static/media/landing-communication-min.e342a3de.svg";